module.exports = __webpack_public_path__ + "components/home-header/static/header-2--huge@2x-478eaf2c669c2f0fa3a2fff0fee76f96.jpg";